// extracted by mini-css-extract-plugin
export default {"footer":"FpMOOdEzGClBTbr7wVxz","body":"Yf6cQB_oB0wM5pmOiZgx","corset":"iceMwS55VlBuDIwLQ4nB","copy":"hfPA0qEgLFETf4jNLJgG","button":"vGJpbxwfA0VV5VzMjUXE"};